import { Link as InternalLink, Link, graphql, useStaticQuery } from "gatsby";
import get from 'lodash/get';
import React from 'react';

import { getPathFromModel } from '../../../utils/link';

import loadable from '@loadable/component';
const ContactForm = loadable(() => import('../contact-form'))

import { GatsbyImage } from "gatsby-plugin-image";
import { ThemeProvider } from "styled-components";
import { THEME_DARK } from "../../../theme/theme";
import {
	StyledAddressText,
	StyledBottom,
	StyledCertification,
	StyledCompanyText,
	StyledContainer,
	StyledContent,
	StyledCopyright,
	StyledGroup,
	StyledLegal,
	StyledLegalLinks,
	StyledLink,
	StyledLogos,
	StyledSocial
} from './footer.styles';

const LinkItem = ({
	link,
}) => {
	let props;
	if (link.model.apiKey === "link_page") {
		const url = getPathFromModel({ ...link.page })
		props = {
			as: Link,
			to: url
		}
	}
	else if (link.model.apiKey === "link_url") {
		props = {
			as: "a",
			target: "_blank",
			href: link.url
		}
	}
	else if (link.model.apiKey === "link_phone") {
		props = {
			as: "a",
			href: `tel:${link.phone}`
		}
	}
	else if (link.model.apiKey === "link_email") {
		props = {
			as: "a",
			href: `mailto:${link.email}`
		}
	}

	if (props) {
		return (
			<li><StyledLink {...props}>{link.label}</StyledLink></li>
		)
	}

	return null;
};

const LinkGroup = ({ label, links }) => {


	return (
		<StyledGroup>
			<h2>{label}</h2>
			<ul>
				{links.map(link => <LinkItem link={link} />)}
			</ul>
		</StyledGroup>
	)
}

const Footer = ({ hideForm, isCompact }) => {
	const data = useStaticQuery(graphql`
		query FooterQuery {
			footer:datoCmsFooter {
				addressLabel
				address
				copyright
				companyInfo
				links {
          ...LinkGroupFragment
        }
				legalLinks {
					... on DatoCmsLegal {
						model {
							apiKey
						}
						slug
						name
					}
				}
				socialLabel
				facebookUrl
				instagramUrl
				certification
				logos{
		
					width
					height
					gatsbyImageData(
						layout: FIXED
					)
					alt
					customData
				}
			}
		}
	`)

	const footer = get(data, "footer");

	if (!footer) return null;

	return (
		<ThemeProvider theme={THEME_DARK}>
			{!hideForm && <ContactForm />}
			<StyledContainer>
				<StyledContent>
					{footer.links.map((linkList, index) => <LinkGroup key={index} {...linkList} />)}
					<StyledGroup>
						<h2>{footer.addressLabel}</h2>
						<StyledAddressText dangerouslySetInnerHTML={{ __html: footer.address }} />
					</StyledGroup>
					<StyledSocial>
						<h2>{footer.socialLabel}</h2>
						<div>
							{footer.instagramUrl && <a href={footer.instagramUrl}>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M7.05 0.065C6.04766 0.0790862 5.05571 0.270366 4.12 0.63C3.32385 0.918887 2.60518 1.38774 2.02 2C1.40761 2.6066 0.930493 3.3359 0.62 4.14C0.275531 5.07268 0.0879907 6.056 0.065 7.05C0 8.325 0 8.74 0 12C0 15.26 0 15.66 0.065 16.95C0.0879907 17.944 0.275531 18.9273 0.62 19.86C0.919031 20.6699 1.39768 21.4016 2.02 22C2.6173 22.5975 3.33248 23.0641 4.12 23.37C5.05147 23.7201 6.03518 23.9111 7.03 23.935C8.305 24 8.72 24 11.98 24C15.24 24 15.64 24 16.93 23.935C17.9264 23.911 18.9118 23.7201 19.845 23.37C20.6505 23.0795 21.3803 22.6112 21.98 22C22.5898 21.401 23.0638 20.678 23.37 19.88C23.7206 18.9487 23.9116 17.9649 23.935 16.97C24 15.695 24 15.28 24 12.02C24 8.76 24 8.36 23.935 7.07C23.9209 6.06766 23.7296 5.07571 23.37 4.14C23.0758 3.33008 22.6003 2.59811 21.98 2C21.3806 1.39309 20.6599 0.919446 19.865 0.61C18.9306 0.266774 17.9453 0.0825563 16.95 0.065C15.675 0 15.26 0 12 0C8.74 0 8.345 0 7.05 0.065ZM7.15 21.75C6.38658 21.7423 5.63031 21.6018 4.915 21.335C4.39608 21.145 3.92748 20.8389 3.545 20.44C3.14614 20.0575 2.84001 19.5889 2.65 19.07C2.38374 18.3545 2.24333 17.5984 2.235 16.835C2.185 15.575 2.17 15.195 2.17 11.985C2.17 8.775 2.17 8.41 2.235 7.135C2.24043 6.37623 2.38096 5.62449 2.65 4.915C2.84122 4.39523 3.14713 3.92525 3.545 3.54C3.92911 3.1443 4.39734 2.84012 4.915 2.65C5.63031 2.38315 6.38658 2.24272 7.15 2.235C8.41 2.185 8.79 2.17 12 2.17C15.21 2.17 15.575 2.17 16.85 2.235C17.6088 2.24043 18.3605 2.38096 19.07 2.65C19.5861 2.84623 20.0547 3.14952 20.4451 3.53991C20.8355 3.93031 21.1388 4.39895 21.335 4.915C21.6006 5.62544 21.741 6.37657 21.75 7.135C21.815 8.39 21.815 8.77 21.815 11.985C21.815 15.2 21.815 15.56 21.75 16.835C21.7417 17.5984 21.6013 18.3545 21.335 19.07C21.1366 19.5848 20.8325 20.0523 20.4424 20.4424C20.0523 20.8325 19.5848 21.1366 19.07 21.335C18.3599 21.6018 17.6085 21.7423 16.85 21.75C15.595 21.8 15.21 21.815 12 21.815C8.79 21.815 8.425 21.815 7.15 21.75ZM16.965 5.58C16.965 5.86481 17.0495 6.14321 17.2077 6.38002C17.3659 6.61683 17.5908 6.8014 17.8539 6.91039C18.1171 7.01938 18.4066 7.04789 18.6859 6.99233C18.9653 6.93677 19.2218 6.79962 19.4232 6.59823C19.6246 6.39685 19.7618 6.14026 19.8173 5.86093C19.8729 5.5816 19.8444 5.29206 19.7354 5.02894C19.6264 4.76581 19.4418 4.54091 19.205 4.38268C18.9682 4.22445 18.6898 4.14 18.405 4.14C18.0235 4.14132 17.658 4.29345 17.3882 4.56322C17.1185 4.83299 16.9663 5.19849 16.965 5.58ZM5.845 12C5.84797 13.2179 6.21189 14.4076 6.89078 15.4187C7.56967 16.4299 8.53306 17.2171 9.6592 17.6809C10.7853 18.1447 12.0237 18.2642 13.2178 18.0244C14.4118 17.7846 15.508 17.1963 16.3678 16.3337C17.2276 15.4711 17.8124 14.373 18.0483 13.1782C18.2842 11.9833 18.1607 10.7454 17.6932 9.62075C17.2258 8.49612 16.4354 7.53529 15.4221 6.85968C14.4088 6.18408 13.2179 5.82401 12 5.825C11.1904 5.82631 10.389 5.98707 9.64152 6.29811C8.89405 6.60914 8.21516 7.06435 7.64361 7.63776C7.07207 8.21116 6.61906 8.89152 6.31045 9.63999C6.00185 10.3885 5.84369 11.1904 5.845 12ZM8.01 12C8.01 11.2089 8.2446 10.4355 8.68412 9.77772C9.12365 9.11992 9.74836 8.60723 10.4793 8.30448C11.2102 8.00173 12.0144 7.92252 12.7904 8.07686C13.5663 8.2312 14.279 8.61216 14.8384 9.17157C15.3978 9.73098 15.7788 10.4437 15.9331 11.2196C16.0875 11.9956 16.0083 12.7998 15.7055 13.5307C15.4028 14.2616 14.8901 14.8864 14.2323 15.3259C13.5745 15.7654 12.8011 16 12.01 16C10.9491 16 9.93172 15.5786 9.18157 14.8284C8.43143 14.0783 8.01 13.0609 8.01 12Z" fill="white" />
								</svg>
							</a>}
							{footer.facebookUrl && <a href={footer.facebookUrl}>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M22.675 0H1.325C0.593 0 0 0.593 0 1.325V22.676C0 23.407 0.593 24 1.325 24H12.82V14.706H9.692V11.084H12.82V8.413C12.82 5.313 14.713 3.625 17.479 3.625C18.804 3.625 19.942 3.724 20.274 3.768V7.008L18.356 7.009C16.852 7.009 16.561 7.724 16.561 8.772V11.085H20.148L19.681 14.707H16.561V24H22.677C23.407 24 24 23.407 24 22.675V1.325C24 0.593 23.407 0 22.675 0V0Z" fill="white" />
								</svg>
							</a>}
						</div>
					</StyledSocial>
					<StyledCertification>
						<StyledLogos>
							{footer.logos.map((logo, index) => (
								<li key={index}>
									{logo.customData.url ? <a href={logo.customData.url} target='_blank' rel='noopener'><GatsbyImage image={logo.gatsbyImageData} alt={logo.alt} style={{ width: `${logo.width * 0.5}px`, height: `${logo.height * 0.5}px` }} /></a> : <GatsbyImage image={logo.gatsbyImageData} alt={logo.alt} style={{ width: `${logo.width * 0.5}px`, height: `${logo.height * 0.5}px` }} />}
								</li>
							))}
						</StyledLogos>
						<div dangerouslySetInnerHTML={{ __html: footer.certification }} />
					</StyledCertification>
					<StyledBottom>
						<StyledLegal>
							<StyledCopyright>{footer.copyright}</StyledCopyright>
							{footer.legalLinks &&
								<StyledLegalLinks>
									{footer.legalLinks.map((link, index) => (
										<li key={index}>
											<InternalLink to={getPathFromModel({ model: link.model, slug: link.slug })}>{link.name}</InternalLink>
										</li>
									))}
								</StyledLegalLinks>
							}
						</StyledLegal>
						<StyledCompanyText>{footer.companyInfo}</StyledCompanyText>
					</StyledBottom>
				</StyledContent>
			</StyledContainer>
		</ThemeProvider>
	)
}

export default Footer;